export default __webpack_public_path__ + "static/media/Email_Preferences_icon.0d696ba9.svg";